import { NgModule } from '@angular/core';
import { SmartEditService } from '@spartacus/smartedit';
import { CustomSmartEditService } from './services/custom-smart-edit.service';

@NgModule({
  providers: [
    {
      provide: SmartEditService,
      useExisting: CustomSmartEditService,
    },
  ],
})
export class CustomSmartEditFeatureModule {}
